import React, { useEffect } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import FormWrapper from '../parts/FormWrapper';

// VARIABLES
const INITIAL_VALUES = {
  initializedDatePicker: '10/1/22',
  initializedOptionDatePicker: '10/24/22',
  initializedDateRangePicker: '10/1/22-10/25/22',
  initializedOptionDateRangePicker: '10/1/22-10/25/22',
  initializedDateTimePicker: '10/1/22 10:00 AM',
  initializedDateMultiPicker: '10/1/22,10/7/22,10/16/22'
}

const SetFieldValues = () => {
  const { setFieldValue } = useFormikContext() || {};

  useEffect(
    () => {
      setFieldValue('datePicker', '10/1/23')
    },
    [setFieldValue]
  )
  
  return null;
}

// MAIN COMPONENT
const DatePickers = () => (
  <FormWrapper
    initialValues={INITIAL_VALUES}
    inline={[
      <Form.Date
        key="datePickerInline"
        name="datePickerInline"
        label="Date Picker"
        //size="sm"
        useOptions
        range
      />
    ]}
  >
    <SetFieldValues />
    <Form.Date
      name="datePicker"
      label="Date Picker"
      required
      //minDate={'10/5/22'}
      //maxDate={'10/15/22'}
      //size="sm"
      //plaintext
      //menuIsOpen
    />
    <Form.Date
      name="initializedDatePicker"
      label="Date Picker (initialized value)"
      required
    />
    <Form.Date
      name="optionDatePicker"
      label="Date Picker (with options)"
      useOptions
      required
    />
    <Form.Date
      name="initializedOptionDatePicker"
      label="Date Picker (initialized with options)"
      useOptions
      required
    />
    <Form.Date
      name="defaultOptionDatePicker"
      label="Date Picker (default with options)"
      useOptions
      useDefault="today"
      required
    />
    <Form.Date.Range
      name="dateRangePicker"
      label="Date Range Picker"
      useApply
      required
    />
    <Form.Date.Range
      name="initializedDateRangePicker"
      label="Date Range Picker (initialized value)"
      useApply
      required
    />
    <Form.Date.Range
      name="optionDateRangePicker"
      label="Date Range Picker (with options)"
      useOptions
      useApply
      required
    />
    <Form.Date.Range
      name="initializedOptionDateRangePicker"
      label="Date Range Picker (initialized with options)"
      useOptions
      useApply
      required
    />
    <Form.Date.Range
      name="defaultOptionDateRangePicker"
      label="Date Range Picker (default with options)"
      useOptions
      useDefault="thisMonth"
      useApply
      required
    />
    <Form.Date.Time
      name="dateTimePicker"
      label="Date/Time Picker"
      required
    />
    <Form.Date.Time
      name="initializedDateTimePicker"
      label="Date/Time Picker (initialized value)"
      //minDate="10/1/22 11:00 AM"
      //minDate="10/2/22"
      //minTime="11:00 AM"
      required
    />
    <Form.Date.Multiple
      name="dateMultiPicker"
      label="Multi-Date Picker"
      required
    />
    <Form.Date
      name="initializedDateMultiPicker"
      label="Multi-Date Picker (initialized value)"
      //minDate={'10/5/22'}
      //maxDate={'10/15/22'}
      multiple
      required
    />
  </FormWrapper>
)

// EXPORT
export default DatePickers
